/*jshint esversion: 6 */
import { Vector as VectorLayer} from 'ol/layer.js';
// import Polygon from 'ol/geom/Polygon';
import {Vector as VectorSource} from 'ol/source.js';
import Draw, { createBox} from 'ol/interaction/Draw.js';
import { Modify } from 'ol/interaction.js';
import Point from 'ol/geom/Point.js';
import Feature from 'ol/Feature.js';
import Select from 'ol/interaction/Select.js';
import * as Extent from 'ol/extent.js'; 
// import * as olExtent from 'ol/extent';
// import * as OLUtil from 'ol/util';
import {
  Circle as CircleStyle,
  Fill,
  Stroke,
  Style,
  Icon
} from 'ol/style.js';
import marker from 'url:../img/marker.png';
let map;
let singleClickController = null;
let modifyController = null;
let boundingBoxController = null;
const iconStyle = new Style({
  stroke: new Stroke({
    color: '#FF9999',
    width: 3
  }),
  image: new Icon({
    anchor: [0.5, 46],
    anchorXUnits: 'fraction',
    anchorYUnits: 'pixels',
    opacity: 0.75,
    src: marker
  })
});
export default {
  setMap: (mapParam) => {
    map = mapParam;
  },
  getMap: () => {
    return map;
  },
  makeBbController: () => {
    var source = new VectorSource();
    var vector = new VectorLayer({
      source: source,
      id: 'bbox',
      style: new Style({
        fill: new Fill({
          color: 'rgba(255, 0, 0, 0.2)'
        }),
        stroke: new Stroke({
          color: '#ff0000',
          width: 2
        }),
        image: new CircleStyle({
          radius: 7,
          fill: new Fill({
            color: '#ff0000'
          })
        })
      })
    });
      // var draw;
      var value = 'Circle';
    //  if (value && !== 'None') {
        var geometryFunction;
          geometryFunction = createBox();
        boundingBoxController = new Draw({
              source: source,
              type: value,
              geometryFunction: geometryFunction
            });
  //  }
    map.addLayer(vector);
    return boundingBoxController;
  },
  // remove existing boundary or marker
  removeLayerById: (name) => {
    map.getLayers().forEach((l) => {
      if (!l) {
        return;
      }
      const id = l.get('id');
      if (id === name) {
        map.removeLayer(l);
      }
    });
  },
  removeInteraction: (name) => {
    map.removeInteraction(name);
  },
  addMarker: (point) => {
    const iconFeature = new Feature({
      geometry: point
    });
    iconFeature.setStyle(iconStyle);
    const source = new VectorSource({
      features: [iconFeature]
    });
    const layer = new VectorLayer({
      id: 'marker',
      source: source
    });
    map.addLayer(layer);
  },
  addBoundary: (boundary) => {
    // Make boundary and add to map
    const source = new VectorSource({
      features: boundary
    });
    const layer = new VectorLayer({
      id: 'boundary',
      source: source,
      style: iconStyle
    });
    map.addLayer(layer);
    return layer;
  },
  createPoint: (coord) => {
    return new Point(coord);
  },
  zoomToPoint: (point, zoom) => {
    const view = map.getView();
    const z = Math.max(view.getZoom(), zoom); // closest
    setTimeout(() => { // needed to see the marker during animation
      view.animate({
        center: point.getCoordinates(),
        zoom: z,
        duration: 1800
      });
    }, 100);
  },
  panToFeature: (feature) => {
    const view = map.getView();
    const extent = feature.getGeometry().getExtent(); 
    const centerFromFeatureExtent = Extent.getCenter(extent); 
    view.animate({
      center: centerFromFeatureExtent,
      duration: 1000,
    });
  },
  zoomToExtent: (feature) => {
    //console.log('OpenLayers Version: ',OLUtil.VERSION);
    // animate don't work for this version 6.3.1
    map.getView().fit(feature.getGeometry(), map.getSize(), { duration: 1000 });
  // with working animate but poor zoom to center
  //var aa = feature.getGeometry().getExtent();
  //var oo = olExtent.getCenter(aa);
  // map.getView().animate({ center:oo }, { duration: 750 });
},
getCurrentZoomLevel: () => {
  return map.getView().getZoom();
},
makeSelectController: () => {
  singleClickController = new Select({layers: function(layer) {
          return layer.get('selectable') == true;
        },
        hitTolerance: 5
      });
  return singleClickController;
},
getSelectController: () => {
  if (singleClickController) {
    return singleClickController;
  } else {
    return null;
  }
},
getModifyController: (featuresFromSelect) => {
  if (modifyController || !featuresFromSelect) {
    return modifyController;
  } else {

     const modify = new Modify({
    features: featuresFromSelect
 });
 return modify;
  }
},
getSource: () => {
    return  new VectorSource();
},
getBoundingBoxController: () => {
  return boundingBoxController;
}



};
